import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[formValidationContainer]'
})
export class FormValidationContainerDirective {
  readonly containerEl: HTMLElement = this.el.nativeElement;

  constructor(protected el: ElementRef) { }

}
